module.exports = __webpack_public_path__ + "img/collapse.26e30ef5.svg";